import dayjs from 'dayjs';
import { FC, useMemo, useRef, useState } from 'react';
import { DelayUnmount } from '../../../components/DelayUnmount';
import { Modal } from '../../../components/Modal';
import {
  toggleTripMap,
  useShowTripMap,
  useTripData,
  useTripImage,
} from '../../../services/history';
import { UUID } from '../../../types';
import styles from './ShowRoute.module.css';
import { FormattedMessage, useIntl } from 'react-intl';

interface ShowRouteProps {}

export const ShowRoute: FC<ShowRouteProps> = () => {
  const { $t } = useIntl();
  const tripId = useShowTripMap();
  const tripIdSaved = useRef<UUID>('');
  const [mapRef, setMapRef] = useState<HTMLDivElement | null>(null);
  const open = !!tripId;

  if (tripId) {
    /** save last tripId to prevent modal content dissapearring
     * while unmount animation is playing */
    tripIdSaved.current = tripId;
  }

  const trip = useTripData(tripIdSaved.current);

  const imagePayload = useMemo(() => {
    if (!mapRef) {
      return {};
    }
    return {
      width: Math.floor(mapRef.clientWidth),
      height: Math.floor(mapRef.clientHeight),
      tripId: tripIdSaved.current,
    };
  }, [mapRef]);

  const image = useTripImage(imagePayload);

  return (
    <DelayUnmount unmount={!open}>
      <Modal
        className={styles.modal}
        open={open}
        title={<FormattedMessage id="Location" />}
        onClose={() => toggleTripMap(null)}
      >
        {trip && (
          <div className={styles.wrapper}>
            <div>
              <div className={styles.date}>
                {$t({ id: 'Route.Start' })}{' '}
                {dayjs(
                  trip.routeWithIgnitionOn.firstCoordinate.dateTime
                ).format('HH:mm')}{' '}
                <span className="light">
                  {dayjs(
                    trip.routeWithIgnitionOn.firstCoordinate.dateTime
                  ).format('ddd, ll')}
                </span>
              </div>
              {trip.routeWithIgnitionOff && (
                <div className={styles.date}>
                  {$t({ id: 'Route.Stop' })}{' '}
                  {dayjs(
                    trip.routeWithIgnitionOff.firstCoordinate.dateTime
                  ).format('HH:mm')}{' '}
                  <span className="light">
                    {dayjs(
                      trip.routeWithIgnitionOff.firstCoordinate.dateTime
                    ).format('ddd, ll')}
                  </span>
                </div>
              )}
            </div>
            <div ref={setMapRef} className={styles.map}>
              {image && <img {...image} className={styles.img} alt="" />}
            </div>
          </div>
        )}
      </Modal>
    </DelayUnmount>
  );
};
